import { Typography } from "@mui/material";
import { type ILoadingButtonStyledProps, LoadingButtonStyled } from "./styles";

export const ResponsiveButton = ({ children, ...props }: ILoadingButtonStyledProps) => {
  return (
    <LoadingButtonStyled {...props}>
      <Typography variant="button">{children}</Typography>
    </LoadingButtonStyled>
  );
};
